export default function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}


//////////////////
// WEBPACK FOOTER
// /home/riforce/domains/riforce.nl/releases/20250205091926/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
// module id = 84
// module chunks = 0